import { render } from "./DiagView.vue?vue&type=template&id=62209ba4&scoped=true&ts=true"
import script from "./DiagView.vue?vue&type=script&lang=ts"
export * from "./DiagView.vue?vue&type=script&lang=ts"

import "./DiagView.vue?vue&type=style&index=0&id=62209ba4&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62209ba4"]])

export default __exports__